import React, { useMemo } from 'react';
import Slot from './Slot';

interface DangerouslySetInnerHTMLProps
  extends Omit<React.HTMLAttributes<HTMLElement>, 'dangerouslySetInnerHTML'> {
  html: string;
}

/**
 * A workaround for React bug: https://github.com/facebook/react/issues/31660
 */
const DangerouslySetInnerHTML = ({
  html,
  ...props
}: DangerouslySetInnerHTMLProps) => {
  const memoizedHtml = useMemo(() => ({ __html: html }), [html]);

  return (
    <Slot
      {...props}
      // eslint-disable-next-line no-restricted-syntax
      dangerouslySetInnerHTML={memoizedHtml}
    />
  );
};

export default DangerouslySetInnerHTML;
